import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TRANSLATE_PREFIX } from '../../consts';
import RequiredInput from '../RequiredInput';
import css from './SingularKeyCell.css';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.TRACKING_LINK_OPTIONS_TAB`;

const SingularKeyCell = ({ row, setParam, readOnly, translate }) => {
    const { isCustomRow, index, singular_key: singularKey, duplicateKey } = row;
    if (isCustomRow) {
        return (
            <td>
                <div className={css.cellWrapper}>
                    <RequiredInput
                        value={singularKey}
                        placeholder={readOnly ? undefined : translate(`${TAB_PREFIX}.CUSTOM_PARAM_KEY_PLACEHOLDER`)}
                        onChange={val => setParam(index, 'singular_key', val)}
                        inputClassName={classNames({ [css.invalidInput]: duplicateKey })}
                        disabled={readOnly}
                    />
                    {duplicateKey && (
                        <span className={css.duplicateHint}>{translate(`${TAB_PREFIX}.DUPLICATE_KEY_HINT`)}</span>
                    )}
                </div>
            </td>
        );
    }
    return (
        <td>
            <code className={css.singularKey}>{singularKey}</code>
        </td>
    );
};

SingularKeyCell.propTypes = {
    row: PropTypes.shape({
        isCustomRow: PropTypes.bool.isRequired,
        index: PropTypes.number.isRequired,
        singular_key: PropTypes.string,
        duplicateKey: PropTypes.bool,
    }).isRequired,
    setParam: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default SingularKeyCell;
